import { supabaseClient } from "@/lib/database/supabase";
import getRouteForPlayer from "@/lib/utils/route/getRouteForPlayer";
import { PlayerSummary, PublicPlayerProfile } from "@shared/lib/database/query.types";
import { defineStore } from "pinia";
import { ref } from "vue";
import useModalStore from "./useModalStore";

export default defineStore("PlayerStore", () => {
  const {
    openModal,
  } = useModalStore();

  const playerMap = ref<Record<string, PlayerSummary | PublicPlayerProfile>>({});

  function getPlayer (playerId: string) {
    return playerMap.value[playerId] || null;
  }

  function setPlayer (playerId: string, player: PlayerSummary | PublicPlayerProfile) {
    playerMap.value[playerId] = player;
  }

  function viewPlayer (player: PlayerSummary | PublicPlayerProfile) {
    if (!player.id) return;

    setPlayer(player.id, player);

    return openModal(getRouteForPlayer(player.id));
  }

  async function fetchPlayer (playerId: string) {
    const {
      data: _player,
    } = await supabaseClient
      .rpc("get_public_player_profile", {
        player_id: playerId,
      })
      .maybeSingle()
      .throwOnError();

    if (_player) {
      setPlayer(playerId, _player);
      return _player;
    }
  }

  return {
    getRouteForPlayer,
    getPlayer,
    setPlayer,
    viewPlayer,
    fetchPlayer,
  };
});
